import axios from "axios";

// Request timeout: 30 seconds
axios.defaults.timeout = 30000;

// Request deduplication — prevents identical in-flight requests from firing twice
const pendingRequests = new Map();

const getRequestKey = (config) => {
  return `${config.method}:${config.url}:${JSON.stringify(config.params || {})}`;
};

// Attach auth token dynamically on every request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  if (token) {
    config.headers["x-access-token"] = token;
    config.headers["Authorization"] = token;
  }
  return config;
});

// Response interceptor — clean up and handle common errors
axios.interceptors.response.use(
  (response) => {
    pendingRequests.delete(getRequestKey(response.config));
    return response;
  },
  (error) => {
    if (error.config) {
      pendingRequests.delete(getRequestKey(error.config));
    }

    // Session expired — clear auth and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("loginType");
      sessionStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
};
